import { render, staticRenderFns } from "./UISources.vue?vue&type=template&id=dcd2dda0&scoped=true&"
import script from "./UISources.vue?vue&type=script&lang=js&"
export * from "./UISources.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/ui.css?vue&type=style&index=0&id=dcd2dda0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd2dda0",
  null
  
)

export default component.exports